import React from 'react';
import { Config } from '@leverege/plugin';
import { Redirect } from 'react-router';
import { GlobalState, UI } from '@leverege/ui-redux';
import { History } from '@leverege/molten-core';
import LostScreen from "../../screens/support/LostScreen.js";
import { getInitialUrl } from "./Factory.js";
import Util from "../Util.js";
const create = molten => {
  return {
    id: 'molten.PersonaInitRoute',
    matches: {
      client: 'Main'
    },
    exact: true,
    path: '/',
    render: ({
      match,
      location,
      history
    }) => {
      const redirectUrl = localStorage.getItem('lastActivePage') || localStorage.getItem('redirectUrl');
      if (redirectUrl) {
        localStorage.removeItem('lastActivePage');
        localStorage.removeItem('redirectUrl');
        return /*#__PURE__*/React.createElement(Redirect, {
          to: redirectUrl
        });
      }
      const {
        activePersona
      } = UI.get(GlobalState.get()) || {};
      let url = getInitialUrl(activePersona);
      if (url == null) {
        let def = Config.get('InitialRoute', 'fallbackUrl');
        if (typeof def === 'function') {
          def = def(molten);
        }
        if (def) {
          const match = {
            params: {
              persona: activePersona.name
            }
          };
          url = Util.resolve(def, match);
        }
      }
      if (url == null) {
        return /*#__PURE__*/React.createElement(LostScreen, null);
      }
      return /*#__PURE__*/React.createElement(Redirect, {
        to: History.adjustPath(url)
      });
    }
  };
};
export default {
  create
};